import type { KeyboardActionId } from "~/keyboard/actionCatalog";

import { createContext } from "react";

export type ShortcutHandler = (event: KeyboardEvent) => boolean | void;

export type RegisterShortcut = (actionId: KeyboardActionId, handler: ShortcutHandler) => () => void;

export interface KeyboardShortcutsContextValue {
	getRegisteredActionIds: () => KeyboardActionId[];
	registerShortcut: RegisterShortcut;
}

const KeyboardShortcutsContext = createContext<KeyboardShortcutsContextValue>({
	getRegisteredActionIds: () => [],
	registerShortcut: () => () => {}
});

export default KeyboardShortcutsContext;
